import { giphyDarkestGrey } from '@giphy/js-brand'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { BUTTON_ACTIVE_OPACITY } from '../../constants'
import { CreationToolUploadContext } from './manager'
import UploadButton from './upload-button'

const Container = styled.div`
    background: ${giphyDarkestGrey};
    bottom: 0;
    margin: 0 -20px;
    padding-bottom: 10px;
    position: sticky;
    text-align: center;
`

const DownloadButton = styled.div`
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin: 20px auto;

    &:active {
        opacity: ${BUTTON_ACTIVE_OPACITY};
    }
`

const CreationUploadButtons = () => {
    const { download, allowDownload } = useContext(CreationToolUploadContext)
    return (
        <Container>
            <UploadButton />
            {allowDownload && <DownloadButton onClick={download}>Download</DownloadButton>}
        </Container>
    )
}

export default CreationUploadButtons
